module.exports = __webpack_public_path__ + "static/img/5f704820.png";